/* eslint-disable prettier/prettier */
/*
public function show_Beitragsberechnung()
    {
        // Head
        if ($this->pagePosition->y < $this->mm2p(85)) {
            $this->nextPage();
        }
        $this->textflow = $this->pdf->add_textflow($this->textflow, "Beitragsberechnung", $this->boldOptions . " fillcolor=" . $this->colors->rgb->headline);
        // $this->textflow = $this->pdf->add_textflow($this->textflow,"\n",$this->distanceOptions);
        // Subhead
        $this->dumpThisTextflow(100);
        // Tabelle
        // a: Tabelle aufbauen
        $opts = "rowjoingroup=1 margin=10 matchbox={ borderwidth=0.5 strokecolor={rgb 1 1 1}} ";
        $whiteCellOpts = "rowjoingroup=1 margin=10 matchbox={ borderwidth=0.5 strokecolor={rgb 1 1 1} fillcolor={rgb 1 1 1}} ";
        $table = 0;
        $tableColId = 1;
        $tableRowId = 1;
        $tableTextflow = $this->pdf->create_textflow(" ", $this->regularOptions);
        $table = $this->pdf->add_table_cell($table, $tableColId, $tableRowId, "", $opts);
        $tableColId = 2;
        $tableTextflow = $this->pdf->create_textflow("Beitrag\nin Euro", $this->regularOptions);
        $table = $this->pdf->add_table_cell($table, $tableColId, $tableRowId, "", $opts . " textflow=$tableTextflow");
        $tableColId = 3;
        $tableTextflow = $this->pdf->create_textflow("Vers.-Steuer\nin Euro", $this->regularOptions);
        $table = $this->pdf->add_table_cell($table, $tableColId, $tableRowId, "", $opts . " textflow=$tableTextflow");
        $tableColId = 4;
        $tableTextflow = $this->pdf->create_textflow("Gesamtbeitrag\nin Euro", $this->regularOptions . " alignment=right");
        $table = $this->pdf->add_table_cell($table, $tableColId, $tableRowId, "", $opts . " textflow=$tableTextflow");
        $tableRowId = 2; // Nächste Zeile
        $tableColId = 1;
        $tableTextflow = $this->pdf->create_textflow("Gemäß monatlichem Zahlungsrhythmus", $this->regularOptions);
        $table = $this->pdf->add_table_cell($table, $tableColId, $tableRowId, "", $opts . " colwidth=55% textflow=$tableTextflow");
        $tableColId = 2;
        $beitragBrutto = $this->viergewinnt->offerRequest->contract->gesamtbeitrag;
        $beitragNetto = $beitragBrutto / 1.19;
        $versSteuer = $beitragBrutto - $beitragNetto;
        $tableTextflow = $this->pdf->create_textflow(number_format($beitragNetto, 2, ',', '.'), $this->regularOptions);
        $table = $this->pdf->add_table_cell($table, $tableColId, $tableRowId, "", $opts . " colwidth=15% textflow=$tableTextflow");
        $tableColId = 3;
        $tableTextflow = $this->pdf->create_textflow(number_format($versSteuer, 2, ',', '.'), $this->regularOptions);
        $table = $this->pdf->add_table_cell($table, $tableColId, $tableRowId, "", $opts . " colwidth=15% textflow=$tableTextflow");
        $tableColId = 4;
        $tableTextflow = $this->pdf->create_textflow(number_format($beitragBrutto, 2, ',', '.'), $this->regularOptions . " alignment=right");
        $table = $this->pdf->add_table_cell($table, $tableColId, $tableRowId, "", $opts . " colwidth=15% textflow=$tableTextflow");
        $tableRowId = 3;
        $tableColId = 1;
        $tableTextflow = $this->pdf->create_textflow("Gesamtbeitrag", $this->regularOptions);
        $table = $this->pdf->add_table_cell($table, $tableColId, $tableRowId, "", $opts . " textflow=$tableTextflow");
        $tableColId = 2;
        $tableTextflow = $this->pdf->create_textflow(number_format($beitragNetto, 2, ',', '.'), $this->regularOptions);
        $table = $this->pdf->add_table_cell($table, $tableColId, $tableRowId, "", $opts . " textflow=$tableTextflow");
        $tableColId = 3;
        $tableTextflow = $this->pdf->create_textflow(number_format($versSteuer, 2, ',', '.'), $this->regularOptions);
        $table = $this->pdf->add_table_cell($table, $tableColId, $tableRowId, "", $opts . " textflow=$tableTextflow");
        $tableColId = 4;
        $tableTextflow = $this->pdf->create_textflow(number_format($beitragBrutto, 2, ',', '.'), $this->regularOptions . " alignment=right");
        $table = $this->pdf->add_table_cell($table, $tableColId, $tableRowId, "", $opts . " textflow=$tableTextflow");

        // b: Tabelle platzieren
        $result = ""; //
        $options = " rowheightdefault=minimum fill={{area=rowodd fillcolor={rgb " . (191 / 255) . " " . (203 / 255) . " " . (233 / 255) . "}} {area=roweven fillcolor={rgb " . (242 / 255) . " " . (244 / 255) . " " . (251 / 255) . "}}}";
        if ($this->pagePosition->y < $this->mm2p(85)) {
            $this->nextPage();
        }
        do {
            if ($result == "_boxfull" || $result == "_nextpage") {
                $this->nextPage();
            }
            $result = $this->pdf->fit_table($table, $this->mm2p(190), $this->pagePosition->y, $this->pagePosition->x, $this->mm2p(35), $options);
            if ($result === '_error') {
                break;  // Tabelle wird ignoriert
            }
        } while ($result == "_boxfull" || $result == "_nextpage");
        $this->pagePosition->y -= $this->mm2p(43.5);
        if ($this->pagePosition->y < $this->mm2p(40)) {
            $this->nextPage();
        }
        // Text unter der Tabelle
        $copy = "Bei der Berechnung des Gesamtbeitrages sind vereinbarte Zuschläge bzw. Nachlässe berücksichtigt.";
        $this->textflow = $this->pdf->add_textflow($this->textflow, $copy, $this->regularOptions . " fillcolor=" . $this->colors->rgb->copy);
        $copy = "\nBei der Berechnung des Beitrages sind 19 % Versicherungsteuer berücksichtigt.\n";
        $this->textflow = $this->pdf->add_textflow($this->textflow, $copy, $this->regularOptions . " fillcolor=" . $this->colors->rgb->copy);
        $this->dumpThisTextflow();
    }
*/
/* 
const beitragBrutto = $this -> viergewinnt -> offerRequest -> contract -> gesamtbeitrag;
const beitragNetto = beitragBrutto / 1.19;
const versSteuer = beitragBrutto - beitragNetto;
 */
const beitragsberechnungHeader = { text: "\nBeitragsberechnung\n\n", style: "subHeadOptions" }
const beitragsberechnungTabelle = {
    style: "tableTextRegular",
    table: {
        widths: [160, 100, 100, 100],
        body: [
            ['', "Beitrag\nin Euro", "Vers.-Steuer\nin Euro", "Gesamtbeitrag\nin Euro"],
            ["Gemäß monatlichem Zahlungsrhythmus", "__beitragNetto__", "__versSteuer__", "__beitragBrutto__"],
            ["Gesamtbeitrag", "__beitragNetto__", "__versSteuer__", "__beitragBrutto__"]
        ]
    }
}
const beitragsberechnungFooter = [
    { text: "\nBei der Berechnung des Gesamtbeitrages sind vereinbarte Zuschläge bzw. Nachlässe berücksichtigt.", style: "regularOptions" },
    { text: "Bei der Berechnung des Beitrages sind 19 % Versicherungsteuer berücksichtigt.\n", style: "regularOptions" },
]

export { beitragsberechnungHeader, beitragsberechnungTabelle, beitragsberechnungFooter }